<template>
  <div class="newsList">
    <div class="position-relative jp-column">
      <el-image :src="mainBg" class="w-100 title-bg"></el-image>
      <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">News</h4>
      <h1 class="jp-title">{{$t('newsList.title')}}</h1>
    </div>
    <section class="pb-0">
      <div class="jp-line"></div>
      <div class="jp-column">
        <span class="title">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('home.NewsRelease')}}</span>
        </span>
        <div class="mt-5 hidden-sm-and-down">
          <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle" v-for="(news, index) in hotNewsList" :key="index">
            <el-col :span="10" :xs="24">
              <div class="jp-overflow-hidden t-card" @click="newsDetail(news.id)">
                <img :src="news.thumbnail" class="image w-100 technology-img">
              </div>
            </el-col>
            <el-col :span="14" :xs="24" class="mb-3">
              <div class="card-content">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="18" class="text-left mb-0">
                    <div class="jp-line-blue"></div>
                    <h3>{{news.title}}</h3>
                  </el-col>
                  <el-col :span="6" class="text-right mb-0">
                    <span class="jp-more ml-3" @click="newsDetail(news.id)">
                      <img :src="iconRight" class="icon-image">
                      <span class="more-text">see more</span>
                    </span>
                  </el-col>
                </el-row>
                <div class="card-text mt-3">
                  <p>{{news.newsBriefing}}</p>
                </div>
                <div class="bottom clearfix text-left">
                  <time class="time">{{news.createTime}}</time>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="mt-5 hidden-sm-and-up">
          <el-row :gutter="12">
            <el-col :span="8" :xs="24" v-for="(news, index) in hotNewsList" :key="index" class="jp-news-list-card mb-3">
              <div @click="newsDetail(news.id)">
                <el-card :body-style="{ padding: '0px' }">
                  <div class="jp-overflow-hidden jp-news-list-img">
                    <img :src="news.thumbnail" class="image" />
                  </div>
                  <div class="jp-news-content">
                    <div class="jp-line-blue"></div>
                    <h3 class="mb-3">{{news.title}}</h3>
                    <div>
                      <p>{{news.newsBriefing}}</p>
                    </div>
                    <div class="bottom clearfix">
                      <time class="time">{{news.createTime}}</time>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
    <section>
      <div class="jp-line"></div>
      <div class="jp-column">
        <span class="title">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('news.allNews')}}</span>
        </span>
        <!-- <div class="jp-search text-right">
          <el-input v-model="queryData.title" @input="search" :placeholder="$t('common.searchTitle')" class="input-with-select search-input" clearable>
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div> -->
        <div class="mt-5">
          <el-row :gutter="12">
            <el-col :span="8" :xs="24" v-for="(news, index) in newsList" :key="index" class="jp-news-list-card mb-3">
              <div @click="newsDetail(news.id)">
                <el-card :body-style="{ padding: '0px' }">
                  <div class="jp-overflow-hidden jp-news-list-img">
                    <img :src="news.thumbnail" class="image" />
                  </div>
                  <div class="jp-news-content">
                    <div class="jp-line-blue"></div>
                    <h3 class="mb-3">{{news.title}}</h3>
                    <div>
                      <p>{{news.newsBriefing}}</p>
                    </div>
                    <div class="bottom clearfix">
                      <time class="time">{{news.createTime}}</time>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getNewsList } from '@/api/websiteApi';
import dateFormat from '@/filters/formatTime'

import iconRight from '@/assets/img/icon-right.svg';
import mainBg from '@/assets/img/news_bg.png';
export default {
  name: 'newsList',
  data () {
    return {
      newsList: [],
      hotNewsList: [],
      mainBg: mainBg,
      iconRight: iconRight,
      queryData: {}
    }
  },
  watch: {
    '$i18n.locale'(val) {
      this.tabLang(val);
    }
  },
  created() {
    this.init();
    this.getWidth();
  },
  methods: {
    init() {
      this.search();
    },
    search() {
      getNewsList(this.queryData).then(res => {
        _.forEach(res, item => {
          item.createTime = dateFormat.formatDate(new Date(item.createTime), 'yyyy-MM-dd')
          item.titleJa = item.titleJa.substr(0, 10) + '...';
          item.titleZh = item.titleZh.substr(0, 10) + '...';
          item.thumbnail = item.thumbnail ? (this.imageBaseUrl + item.thumbnail.split('..')[1]) : '';
        });
        this.newsList = res;
        this.hotNewsList.push(res[0]);
        this.hotNewsList.push(res[1]);
        this.tabLang(this.$i18n.locale)
      })
    },
    tabLang(val) {
      _.forEach(this.newsList, item => {
        if (val === 'cn') {
          item.title = item.titleZh;
          item.newsBriefing = item.newsBriefingZh.substr(0,50) + '...';
        }if (val === 'en') {
          item.title = item.titleEn;
          item.newsBriefing = item.newsBriefingEn.substr(0,50) + '...';
        }if (val === 'jp') {
          if (item.titleJa) {
            item.title = item.titleJa;
          }
          if (item.newsBriefingJa) {
            item.newsBriefing = item.newsBriefingJa.substr(0,50) + '...';
          }
        }
      });
    },
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.rowType = ''
      } else {
        this.rowType = 'flex'
      }
    },
    newsDetail(id) {
      this.$router.push({ name: 'new', params: { id: id } });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';

section {
  h2 {
    font-size: 2rem;
  }

  .newsList-introduce {
    width: 1170px;
    margin: 0 auto;
    text-align: left;
    line-height: 2.25rem;
  }

  .jp-project-content {
    font-size: 1.4rem;
    .el-col {
      margin-bottom: 2.5rem;
    }
  }
  .search-input {
    width: 500px;
  }
  .jp-news-list {
    border-top: 1px solid $newsGrey;
    padding: 1.2rem 0;
  }
  .jp-news-list:last-child {
    border-bottom: 1px solid $newsGrey;
  }
  .jp-news-content {
    p {
      font-size: 1rem;
    }
  }
}

@media (max-width: 768px) {
  .newsList {
    section {
      .jp-project-content {
        font-size: 1.7rem;

        .el-image {
          max-height: 104px;
        }
        .el-col {
          margin-bottom: 0;
        }
      }
      .newsList-introduce {
        width: 100%;
        line-height: 2.5rem;
        font-size: 1.6rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/newsList.vue